<template lang="html">

    <div class="cover-popup row-center" v-if="datosEmpresa || datosContacto">
      <div class="popup">

  
        <h2 class="title-pop">{{$t('popup_faltan_datos_empresa.atencion')}}</h2>

        <p v-if="datosContacto">{{$t('popup_faltan_datos_empresa.cuerpo_1')}}</p>
        <p v-else>{{$t('popup_faltan_datos_empresa.cuerpo_2')}}</p>
  
        <div class="contenedor-botones">
  
          <router-link v-if="datosContacto" :to="$t('enlaces.mi_perfil')" class="btn -solid-primary">{{$t('popup_faltan_datos_empresa.ir_a_perfil')}}</router-link>
          <router-link v-else :to="$t('enlaces.mi_empresa')" class="btn -solid-primary">{{$t('popup_faltan_datos_empresa.ir_a_empresa')}}</router-link>
  
        </div>
  
      </div>
    </div>
  
  </template>
  
  <script lang="js">
    
      import {mapGetters,mapActions} from 'vuex';
    
      export default  {
        name: 'popup-faltan-datos-empresa',
        mounted(){
            if(this.datosContacto){
              this.checkFaltanDatosContacto();
            }

            if(this.datosEmpresa){
                this.checkFaltanDatosEmpresa();
            }
        },
        computed : {
          ...mapGetters({
            brand:'getBrand',
            style : 'getStyles',
            datosEmpresa : 'getFaltanDatosAlaEmpresa',
            datosContacto : 'getFaltanDatosAlContacto'
          })
        },
        methods : {
          ...mapActions(['checkFaltanDatosContacto','checkFaltanDatosEmpresa']),
        }
      }
    </script>
  <style scoped lang="scss">
  
    
    
    </style>


// WEBPACK FOOTER //
// submodules/dotia-base-fp/src/components/parts/popup-faltan-datos-empresa.vue